import axios from 'axios';


const state = () => ({
    user: null,
    auth: false
});

const getters = {};

const actions = {
    async logout({ dispatch }) {
        await axios.post('/logout');
        return dispatch('unsetUser');
    },

    async getUser({ commit, rootState }) {
        await axios.get('api/user').then(res => {
            commit('SET_USER', res.data);
            commit('SET_AUTH', true)
        }).catch(() => {
            axios.get('api/user/from-email', {
                    params: {
                        email: rootState.guests.email
                    }
                }).then(res => {
                    if (res.data.user) {
                        commit('SET_USER', res.data.user)
                        commit('SET_AUTH', false)
                    } else {
                        commit('UNSET_USER')
                    }
                })
                .catch(() => commit('UNSET_USER'))
        })
    },

    unsetUser({ commit }) {
        commit('UNSET_USER');
    }
};

const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },
    SET_AUTH(state, loggedIn) {
        state.auth = loggedIn
    },
    UNSET_USER(state) {
        state.auth = false;
        state.user = null;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}